<template>
  <v-card
    class="pa-6 detail-info-card"
    :class="{ 'detail-info-card--no-border': noBorder }"
    rounded="md"
    :elevation="noBorder ? 0 : undefined"
    :variant="noBorder ? 'flat' : 'elevated'"
  >
    <div class="d-flex align-center text-h6 font-weight-bold detail-info-card__header">
      <v-icon :color="iconColor" class="mr-2">{{ icon }}</v-icon>
      <span>{{ title }}</span>
      <v-tooltip v-if="tooltipDescription" location="top">
        <template #activator="{ props }">
          <v-icon
            v-bind="props"
            size="18"
            class="ml-2 detail-info-card__tooltip-icon">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span style="font-size: 12px">{{ tooltipDescription }}</span>
      </v-tooltip>
    </div>
    <div class="detail-info-card__content">
      <slot />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DetailInfoCard',
  props: {
    title: {
      type: String,
      default: 'Information',
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
    iconColor: {
      type: String,
      default: 'indigo',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    tooltipDescription: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.detail-info-card__content {
  margin-top: 16px;
}
.detail-info-card--no-border {
  border: none !important;
  box-shadow: none !important;
}
.detail-info-card__tooltip-icon {
  color: #64748b;
  cursor: pointer;
}
</style>
